<router-outlet>
</router-outlet>

<m-toast [toast]="toast" *ngFor="let toast of gs.toasts; let i=index" [index]="i" ></m-toast>

